import React from 'react';
import { FaEllipsisH } from 'react-icons/fa';
import { Button } from '../design-system';

const Ellipsis = React.forwardRef<
  HTMLButtonElement,
  React.HTMLAttributes<HTMLButtonElement>
>((props, ref) => (
  <Button
    ref={ref}
    id="ellipsis-button"
    variant="greyText"
    type="button"
    aria-label="Show More"
    {...props}
  >
    <FaEllipsisH />
  </Button>
));

export default Ellipsis;
